module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2zM6 11.603V21.5a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-9.895l-9.41 7.154a1 1 0 01-1.18 0L6.02 11.62zM24.807 10H7.193L16 16.713z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-mail.svg
// module id = 695
// module chunks = 0